import React from "react";
import Policy from "./Policy.jsx";
import CancelPolicySkeleton from "./Skeletons/CancelPolicySkeleton.jsx";
import Card from "../common/Card";

const CancellationPolicyBanner = ({
  loading,
  multiplePolicies,
  allowCancel,
  allowUpdate,
  producerName,
  hasCancellationPolicySection,
}) => {
  const renderPolicyContent = () => {
    if (multiplePolicies)
      return (
        <div className="r_multipleCancellationPoliciesText">
          {cancellationpolicy_resources.MultipleCancellationPolicies}
        </div>
      );

    return (
      <Policy
        allowCancel={allowCancel}
        allowUpdate={allowUpdate}
        producerName={producerName}
      />
    );
  };

  if (loading) return <CancelPolicySkeleton />;

  if (hasCancellationPolicySection)
    return (
      <div className="CancellationPolicyInfoDiv">
        <Card
          title={cancellationpolicy_resources.CancellationPolicyHeaderText}
          icon="/Site/images/icons/eventpage/cancellation.svg"
          size="bold"
          noContentPadding
          noMargin
        >
          {renderPolicyContent()}
        </Card>
      </div>
    );

  return "";
};

export default CancellationPolicyBanner;
